import React, { forwardRef } from 'react'
import { useCarromm } from '../../context/carrom'
import { toast } from 'react-hot-toast'
import { isValidImageType, validateFileContent } from '../../utilities'
const UploadInput = forwardRef((props, ref) => {
  const carrom = useCarromm()
  const createId = key => {
    if (carrom?.previewImages?.length > 0) {
      const id = parseInt(carrom?.previewImages?.length) + parseInt(key)
      return parseInt(id)
    } else {
      return parseInt(key)
    }
  }
  const handleFileInput = async e => {
    e.preventDefault()
    const { files } = e.target
    if (e.target.files.length > 0) {
      let images = files
      let imagesList = []
      for (let key in images) {
        if (images.hasOwnProperty(key)) {
          const file = images[key]
          if (!isValidImageType(file)) {
            toast.error('Invalid file type. Only image files are allowed.')
            continue
          }
          try {
            await validateFileContent(file)
          } catch (error) {
            toast.error(error)
            continue
          }

          const varibles = {
            id: key,
            file: null,
            url: window.URL.createObjectURL(images[key]),
            urlStatus: (
              <img
                src='/icons8-upload-to-cloud.gif'
                alt='Hochladen in die Cloud'
              />
            ),
            value: null,
            uploadStatus: '',
            response: null,
            sku_id: null,
            input_url: null,
            output_url: null,
            error: null
          }
          imagesList.push(varibles)
          carrom?.input.push(images[key])
        }
      }
      carrom?.setPreviewImages(imagesList)
      carrom.setHoldFile(imagesList)
    }
  }
  const dropHandler = async e => {
    e.preventDefault()
    const { files, items } = e.dataTransfer
    if (items[0]?.kind === 'file') {
      if (files.length > 0) {
        let images = files
        let imagesList = []
        for (let key in images) {
          if (images.hasOwnProperty(key)) {
            const file = images[key]
            if (!isValidImageType(file)) {
              toast.error('Invalid file type. Only image files are allowed.')
              continue
            }
            try {
              await validateFileContent(file)
            } catch (error) {
              toast.error(error)
              continue
            }
            const varibles = {
              id:
                images.length > 1
                  ? createId(key)
                  : parseInt(carrom?.previewImages?.length),
              file: null,
              url: window.URL.createObjectURL(images[key]),
              urlStatus: (
                <img
                  src='/icons8-upload-to-cloud.gif'
                  alt='Hochladen in die Cloud'
                />
              ),
              value: null,
              uploadStatus: '',
              response: null,
              sku_id: null,
              input_url: null,
              output_url: null,
              error: null
            }
            imagesList.push(varibles)
            carrom?.input.push(images[key])
            // carrom?.setPreviewImages([
            //   ...(carrom?.previewImages || []),
            //   varibles
            // ])
            // carrom?.setHoldFile([...(carrom?.holdFile || []), varibles])
          }
        }
        carrom?.setPreviewImages(prevImages => [...prevImages, ...imagesList])
        carrom.setHoldFile(prevFiles => [...prevFiles, ...imagesList])
        // carrom?.setPreviewImages(imagesList)
        // carrom.setHoldFile(imagesList);
        //carrom?.setPreviewImages([...carrom?.previewImages || [], {window.URL.createObjectURL(images[key])}]);
        // carrom?.setHoldFile([...carrom?.holdFile || [], varibles]);
      }
    } else {
      document.addEventListener('drop', function (e) {
        e.preventDefault()
        e.dataTransfer.items[0].getAsString(function (url) {
          // if (url?.includes("base64")) {
          //   toast("this file is base64")
          //   return
          // }
          if (url?.endsWith('/')) {
            toast('Please enter valid image.')
            return
          }
          const varibles = {
            id: carrom?.previewImages?.length,
            file: e.dataTransfer.files[0],
            url: url,
            urlStatus: (
              <img
                src='/icons8-upload-to-cloud.gif'
                alt='Hochladen in die Cloud'
              />
            ),
            value: url,
            uploadStatus: 'Start uploading...',
            response: null,
            sku_id: null,
            input_url: null,
            output_url: null,
            error: null
          }
          // carrom?.sh
          // carrom?.input.push(files[0])
          // carrom?.setPreviewImages([{ url }])
          // carrom.setHoldFile([varibles]);
          carrom?.setPreviewImages([...(carrom?.previewImages || []), { url }])
          carrom?.setHoldFile([...(carrom?.holdFile || []), varibles])
        })
      })
    }
  }
  const onDragHandle = e => {
    document.addEventListener('dragover', function (e) {
      e.preventDefault()
      return false
    })
  }

  return (
    <label className='upload-area'>
      <input
        type='file'
        name=''
        onChange={e => {
          handleFileInput(e)
        }}
        accept='image/*'
        onDrop={event => dropHandler(event)}
        onDragEnter={event => onDragHandle(event)}
        multiple
        ref={ref}
      />
      <span className='upload-area-icon'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='340.531'
          height='419.116'
          viewBox='0 0 340.531 419.116'
        >
          <g id='files-new' clipPath='url(#clip-files-new)'>
            <path
              id='Union_2'
              data-name='Union 2'
              d='M-2904.708-8.885A39.292,39.292,0,0,1-2944-48.177V-388.708A39.292,39.292,0,0,1-2904.708-428h209.558a13.1,13.1,0,0,1,9.3,3.8l78.584,78.584a13.1,13.1,0,0,1,3.8,9.3V-48.177a39.292,39.292,0,0,1-39.292,39.292Zm-13.1-379.823V-48.177a13.1,13.1,0,0,0,13.1,13.1h261.947a13.1,13.1,0,0,0,13.1-13.1V-323.221h-52.39a26.2,26.2,0,0,1-26.194-26.195v-52.39h-196.46A13.1,13.1,0,0,0-2917.805-388.708Zm146.5,241.621a14.269,14.269,0,0,1-7.883-12.758v-19.113h-68.841c-7.869,0-7.87-47.619,0-47.619h68.842v-18.8a14.271,14.271,0,0,1,7.882-12.758,14.239,14.239,0,0,1,14.925,1.354l57.019,42.764c.242.185.328.485.555.671a13.9,13.9,0,0,1,2.751,3.292,14.57,14.57,0,0,1,.984,1.454,14.114,14.114,0,0,1,1.411,5.987,14.006,14.006,0,0,1-1.411,5.973,14.653,14.653,0,0,1-.984,1.468,13.9,13.9,0,0,1-2.751,3.293c-.228.2-.313.485-.555.671l-57.019,42.764a14.26,14.26,0,0,1-8.558,2.847A14.326,14.326,0,0,1-2771.3-147.087Z'
              transform='translate(2944 428)'
              fill='var(--c-action-primary)'
            />
          </g>
        </svg>
      </span>
      <span className='upload-area-title'>
        Ziehen Sie die Datei(en) zum Hochladen hierher.
      </span>
      <span className='upload-area-description'>
        Alternativ können Sie eine Datei auswählen, indem Sie <br />
        <strong>hier klicken</strong>
      </span>
    </label>
  )
})

export default UploadInput
